/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatDetailResponse } from '../../models/chat-detail-response';

export interface GetChatDetail$Params {
  id: number;
}

export function getChatDetail(http: HttpClient, rootUrl: string, params: GetChatDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getChatDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChatDetailResponse>;
    })
  );
}

getChatDetail.PATH = '/api/chat/{id}';
